(function () {
	angular
		.module('trackeye')
		.factory('Configuration', _ConfigurationFactory);

	_ConfigurationFactory.$inject = ["C4ApiService", "$q"];

	function _ConfigurationFactory(api, $q) {

		/**
		 * @param {string} name
		 * @param {string} description
		 * @param {object} data
		 * @constructor
		 */
		function Configuration(name, description, data) {
			this.id = undefined;
			this.href = undefined;
			this.type = undefined;
			this.name = name;
			this.description = description;
			this.data = data || {};

			this.isNew = true;
		}

		/**
		 * Get a property from the configuration data
		 * @param {string} path
		 * @returns {*|undefined}
		 */
		Configuration.prototype.get = function (path) {
			if (this.data)
				return _traverseObjectByString(path, this.data);

			return undefined;
		};

		/**
		 * Set a property on the configuration data object
		 * @param {string} key
		 * @param {*} value
		 */
		Configuration.prototype.set = function (key, value) {
			this.data[key] = value;

			return this;
		};

		/**
		 * Deletes a property from the configuration data object
		 * @param {string} key
		 * @returns {Configuration}
		 */
		Configuration.prototype.unset = function (key) {
			delete this.data[key];

			return this;
		};

		Configuration.prototype.setName = function (name) {
			this.name = name;

			return this;
		};

		Configuration.prototype.setDescription = function (description) {
			this.description = description;

			return this;
		};

		/**
		 * Sets the data property of the configuration
		 * @param data
		 * @returns {Configuration}
		 */
		Configuration.prototype.setData = function (data) {
			this.data = data;

			return this;
		};

		/**
		 * Saves the configuration to the api
		 * @param {string} [href]
		 * @returns {Promise}
		 */
		Configuration.prototype.save = function (href) {
			var defer = $q.defer();

			api.saveConfiguration(this.id, {
				name: this.name,
				description: this.description,
				data: this.data
			}, this.isNew, href).then((function (response) {
				if (this.isNew) {
					this.id = response.data.id;
					this.type = response.data.type;
					this.isNew = false;
				}

				defer.resolve(this);
			}).bind(this), function (response) {
				defer.reject(response);
			});

			return defer.promise;
		};

		/**
		 * Asserts if the configuration, has been saved to the backend
		 * @returns {boolean}
		 */
		Configuration.prototype.isNew = function () {
			return this.isNew;
		};

		/**
		 * @returns {Promise}
		 */
		Configuration.prototype.delete = function () {
			return api.deleteConfiguration(this.id);
		};

		/**
		 * This populates the object, with given data. Will also
		 * treat the object as already existing
		 * @param {object} data
		 * @returns {Configuration}
		 */
		Configuration.prototype.populate = function (data) {
			this.isNew = false;

			for (var key in data) {
				if (data.hasOwnProperty(key)) {
					this[key] = data[key];
				}
			}

			return this;
		};

		/**
		 * Merge a copy of another configuration, this is useful if
		 * you want to keep references working for this instance.
		 *
		 * @param {Configuration} config
		 */
		Configuration.prototype.copy = function (config) {
			if (!(config instanceof Configuration))
				return;

			for (var key in config) {
				if (config.hasOwnProperty(key)) {
					this[key] = config[key];
				}
			}
		};

		return Configuration;
	}
}());